import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=1756428c&scoped=true&"
import script from "./Period.vue?vue&type=script&lang=js&"
export * from "./Period.vue?vue&type=script&lang=js&"
import style0 from "./Period.vue?vue&type=style&index=0&id=1756428c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1756428c",
  null
  
)

export default component.exports